import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';
import { Translator } from '../translator.interface';
import { Notification, NotificationBackend } from './notification.interfaces';

export class NotificationTranslator
  implements Translator<NotificationBackend, Notification>
{
  translateOneToBackendModel(resource: Notification): NotificationBackend {
    // TODO: validate model
    return {
      id: resource.id,
      modelType: ModelTypes.Notification,
      accountId: resource.accountId,
      createdByUserId: resource.createdByUserId,
      mainText: resource.mainText,
      notificationTime: resource.notificationTime,
      linkType: resource.linkType,
      linkId: resource.linkId,
      read: resource.read,
    };
  }

  translatePartialToBackendModel(
    resource: Notification,
  ): Partial<NotificationBackend> & Required<DataStoreModel> {
    const allProps = this.translateOneToBackendModel(resource);
    const partialProps: Partial<NotificationBackend> &
      Required<DataStoreModel> = {
      id: resource.id,
      modelType: ModelTypes.Notification,
    };
    Object.keys(resource).forEach((key) => {
      partialProps[key] = allProps[key];
    });
    return partialProps;
  }

  translate(resources: NotificationBackend[]): Notification[] {
    // TODO: validate model
    return resources.map((resource) => {
      return this.translateOne(resource);
    });
  }
  translateOne(resource: NotificationBackend): Notification {
    return {
      id: resource.id,
      modelType: ModelTypes.Notification,
      accountId: resource.accountId,
      createdByUserId: resource.createdByUserId,
      mainText: resource.mainText,
      createdAt: resource.createdAt,
      linkType: resource.linkType,
      linkId: resource.linkId,
      read: resource.read,
    };
  }
}
